
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { Tooltip } from "antd";

import { getCookie } from '../common_component/cookie.js';
import StatusBadge from "../common_component/StatusBadge.js";
import PageError from "../common_component/PageError.js";
import { useAuthData } from "./auth-provider.js";

export const ViewEwayBill = (props) => {

	const [ewayBillDetails, setEwayBillDetails] = useState(null);
	const [ewayBillHistory, setEwayBillHistory] = useState([]);
	const [warehouseList, setWarehouseList] = useState([])
	const [configGstinList, setConfigGstinList] = useState([])

	const [Item_details, setItem_details] = useState([]);
	const [Tax_details, setTax_details] = useState([]);
	const [Billing_address, setBilling_address] = useState({});
	const [Shipping_address, setShipping_address] = useState({});
	const [GST_Details, setGST_Details] = useState({});

	const [Adjustment_value, setAdjustment_value] = useState("");
	const [Adjustment_text, setAdjustment_text] = useState("");

	const [approvalChainPopup, setApprovalChainPopup] = useState(false)

	const [approveFinalButtonShow, setApproveFinalButtonShow] = useState(false)
	const [approveButtonShow, setApproveButtonShow] = useState(false)
	const [cancelButtonShow, setCancelButtonShow] = useState(false)

	const [state, setstate] = useState(2);
	const history = useHistory()
	const [failedPageMessage, setFailedPageMessage] = useState("Something went wrong. Please reload this page.")

	const [subTotal, setSubTotal] = useState(0)

	const [configGstinListModalShow, setConfigGstinListModalShow] = useState(false);
	const [configGstinListModalMode, setConfigGstinListModalMode] = useState(null);
	const [selectedOrganizationGstin, setSelectedOrganizationGstin] = useState(null)

	const [submitButtonState, setSubmitButtonState] = useState(false)

	const [fetchedDataModalShow, setFetchedDataModalShow] = useState(false)
	const [fetchedEwayBillData, setFetchedEwayBillData] = useState(null)

	var page_name = "view-e-way-bill";

	const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	async function getEwayBillDetails() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-e-way-bill-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "eway_bill_uid": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// console.log(body);

		if (body.operation === "success") {
			setEwayBillDetails(body.data);

			setAdjustment_value(body.data.adjustment.value);
			setAdjustment_text(body.data.adjustment.text);

			setItem_details(body.data.item_array);

			let arr = [];
			body.data.item_array.forEach((obj, index) => {
				if (obj.taxable === 0) {
					obj.taxable_amount = 0;
				}
				else {
					obj.total_taxable_amount = Math.round((((obj.quantity * obj.rate) - (obj.discount_type === "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * (obj.tax_group_percentage / 100)) * 1000) / 1000;
					obj.taxable_amount = Number(obj.rate) * obj.tax_group_percentage / 100;
				}

				if (obj.tax_calculation_method === "TAX_Exclusive") {
					obj.TAX_Inclusive_Price = Number(obj.rate) + obj.taxable_amount;
					obj.TAX_Exclusive_Price = obj.rate;
				}
				else {
					obj.TAX_Inclusive_Price = Number(obj.rate) + obj.taxable_amount;
					obj.TAX_Exclusive_Price = obj.rate;
				}

				obj.total_tax = obj.tax_group_details == null ? 0 : obj.tax_group_details.reduce((p, o) => { return p + Number(o.tax_percentage) }, 0);
				if (obj.tax_group_details != null) {
					obj.tax_group_details.forEach((obj1, index1) => {
						if (arr.find(x => x.tax_id === obj1.tax_id)) {
							let p = arr.find(x => x.tax_id === obj1.tax_id);
							p.tax_amount = p.tax_amount + Math.round((Number(obj.total_taxable_amount) * Number(obj1.tax_percentage) / Number(obj.total_tax)) * 1000) / 1000;
						}
						else {
							let json = {};
							json.tax_id = obj1.tax_id;
							json.tax_type = obj1.tax_type;
							json.tax_name = obj1.tax_name;
							json.tax_percentage = obj1.tax_percentage;
							json.tax_amount = Math.round((Number(obj.total_taxable_amount) * Number(obj1.tax_percentage) / Number(obj.total_tax)) * 1000) / 1000;
							arr.push(json);
						}
					});
				}

				// console.log(obj)
			})

			// console.log(arr)
			setTax_details(arr);

			setSubTotal(Math.round(body.data.item_array.reduce((p, o) => { return p + (((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) + (o.taxable === 0 ? 0 : ((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) * (o.tax_group_percentage / 100))) }, 0) * 1000) / 1000)
			setBilling_address(body.data.billing_address)
			setShipping_address(body.data.shipping_address)
			setGST_Details(body.data.gstin_details)


			if (body.data.add_status !== "EWAY_BILL_PENDING_APPROVAL") {
				return
			}

			if (user_role == "Admin") {
				setApproveFinalButtonShow(true)
				setCancelButtonShow(true)
			}

			let t1 = body.data.approval_info
			let t2 = body.data.add_status
			let t3 = body.data.approval_level
			let t4 = t1.value.length
			if (t2 == "EWAY_BILL_PENDING_APPROVAL") {
				if (t1.type == "multilevel_approval") {

					let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
					if (tl.includes(user.email)) {
						setApproveButtonShow(true)
					}

					let tl2 = t1.value.map(x => x.user_value).flat(1)
					if (tl2.includes(user.email)) {
						setCancelButtonShow(true)
					}
				}
				else if (t1.type == "custom_approval") {
					let ty = t1.value[0]
					if (ty.user_type == "Group User") {
						if (ty.user_value.includes(user_role)) {
							setApproveButtonShow(true)
							setCancelButtonShow(true)
						}
					}
					else if (ty.user_type == "Individual User") {
						if (ty.user_value.includes(user.email)) {
							setApproveButtonShow(true)
							setCancelButtonShow(true)
						}
					}
				}
			}
		} else {
			throw body.message
		}
	}

	async function getEwayBillHistory() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-e-way-bill-history`, { method: 'POST', body: JSON.stringify({ "email": user.email, "eway_bill_uid": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// console.log(body);
		if (body.operation === "success" && body.data.length > 0) {
			setEwayBillHistory(body.data);
		}
	}
	async function getWarehouses() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation === "success") {
			setWarehouseList(body.data)
		}
	}
	async function getConfigGstinList() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-e-way-bill-config-status-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// console.log(body)
		if (body.length !== 0) {
			setConfigGstinList(body.data)
		}
	}

	useEffect(() => {
		if ((read || write) && (user.email && visibility)) {

			let p1 = getEwayBillDetails()
			let p2 = getEwayBillHistory()
			let p3 = getWarehouses()
			let p4 = getConfigGstinList()

			Promise.all([p1, p2, p3])
				.then(() => {
					setstate(1);
					console.log("all apis done")
				})
				.catch((err) => {
					console.log(err)

					setstate(3)
					setFailedPageMessage(err)
				})
		}
	}, [user, visibility, read, write])

	const approveEwayBillSubmit = (final_flag, cancel_flag, cancel_msg) => {

		var object = {};

		object.final_flag = final_flag
		object.cancel_flag = cancel_flag
		object.cancel_msg = cancel_msg
		object.eway_bill_uid = props.match.params.id
		object.user_email = user.email
		object.user_role = user_role

		object.organization_id = organization_id
		object.page_name = page_name;

		console.log(object);
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-e-way-bill`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				swal("Great!", "E-Way Bill reviewed successfully!", "success").then(() => { history.push("/e-way-bill-list") })
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	// const handleDownload = () => {
	// let nw = window.open()

	// let html_code = `
	// 		<div class="container-fluid my-5">
	// 			<table class="table table-bordered">
	// 				<tr>
	// 					<td>
	// 						Org. Name: {{organization_name}} <br> 
	// 						Branch Address: {{branch}} <br> 
	// 						State: {{state}} <br> 
	// 						Pincode: {{pincode}} <br> 
	// 						GSTIN: {{gstin}} <br> 
	// 					</td>
	// 					<td>{{document_type}} No. <br> {{document_no}}</td>
	// 					<td>{{document_type}} Date <br> {{document_date}}</td>
	// 				</tr>
	// 				<tr>
	// 					<td rowspan="2">Consignee (Bill to) <br> {{billing_address}} <br> {{billing_pincode}} <br> {{billing_phone}} </td>
	// 					<td>{{document_type}} Total<br> {{document_total}}</td>
	// 					<td>Due Date <br> {{due_date}}</td>
	// 				</tr>
	// 				<tr>
	// 					<td>Reference No. <br> {{reference_no}}</td>
	// 					<td rowspan="3">{{qr_code}}</td>
	// 				</tr>
	// 				<tr>
	// 					<td>Buyer (Ship to) <br> {{shipping_address}} <br> {{shipping_pincode}} <br> {{shipping_phone}} </td>
	// 					<td>Place of Supply<br> {{place_of_supply}}</td>
	// 				</tr>
	// 			</table>

	// 			<table class="table table-bordered my-1">
	// 				<thead>
	// 					<tr>
	// 						<th rowspan="2">Sl No.</th>
	// 						<th rowspan="2">Description of Goods</th>
	// 						<th rowspan="2">HSN/SAC</th>
	// 						<th rowspan="2">Quantity</th>
	// 						<th rowspan="2">Rate</th>
	// 						<th rowspan="2">Discount</th>
	// 						{{tax_column_head1}}
	// 						<th rowspan="2">Amount</th>
	// 					</tr>
	// 					<tr>
	// 						{{tax_column_head2}}
	// 					</tr>
	// 				</thead>
	// 				<tbody>
	// 					##
	// 					<tr>
	// 						<td>{{sl_no}}</td>
	// 						<td>{{description_of_goods}}</td>
	// 						<td>{{product_tax_code}}</td>
	// 						<td>{{quantity}}</td>
	// 						<td>{{rate}}</td>
	// 						<td>{{discount_amount}}</td>
	// 						{{tax_column_details}}
	// 						<td>{{amount}}</td>
	// 					</tr>
	// 					##
	// 				<tbody>
	// 				<tfoot>
	// 					<tr>
	// 						<td colspan="6" rowspan="{{footer_row_count}}">
	// 							Total in Words <br> {{total_in_words}} <br><br>
	// 							Customer Note <br> {{customer_note}} <br><br>
	// 							Terms and Conditions <br> {{terms_and_conditions}} <br><br>
	// 						</td>
	// 						<td colspan="{{tax_column_count}}">SubTotal</td>
	// 						<td>{{subtotal}}</td>
	// 					</tr>
	// 					{{tax_total_details}}
	// 					{{tds_tcs_details}}
	// 					<tr>
	// 						<td colspan="{{tax_column_count}}">{{adjustment_text}}</td>
	// 						<td>{{adjustment_value}}</td>
	// 					</tr>
	// 					<tr>
	// 						<td colspan="{{tax_column_count}}">{{document_type}} Grand Total</td>
	// 						<td>{{document_total}}</td>
	// 					</tr>
	// 				</tfoot>
	// 			</table>

	// 		</div>

	// 		<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>
	// 	`

	// //processing data
	// html_code = html_code.replaceAll("{{organization_name}}", organization_name)
	// html_code = html_code.replaceAll("{{branch}}", ewayBillDetails.branch_name)

	// let tbr = branchList.find(x => x.branch_id == ewayBillDetails.branch_id)
	// html_code = html_code.replaceAll("{{state}}", tbr.branch_address_state)
	// html_code = html_code.replaceAll("{{pincode}}", tbr.branch_address_zipcode)
	// html_code = html_code.replaceAll("{{gstin}}", tbr.GstIn)

	// html_code = html_code.replaceAll("{{document_type}}", "Invoice")
	// html_code = html_code.replaceAll("{{document_no}}", ewayBillDetails.invoice_number)
	// html_code = html_code.replaceAll("{{document_date}}", moment(ewayBillDetails.invoice_date).format("ll"))

	// let tb = JSON.parse(ewayBillDetails.billing_address)
	// html_code = html_code.replaceAll("{{billing_address}}", `${tb.address_line1 == "" ? "" : tb.address_line1 + ", "}${tb.address_line2 == "" ? "" : tb.address_line2 + ", "}${tb.city == "" ? "" : tb.city + ", "}${tb.state == "" ? "" : tb.state + ", "}${tb.country == "" ? "" : tb.country + ", "}`)
	// html_code = html_code.replaceAll("{{billing_pincode}}", `Pincode: ${tb.pincode}`)
	// html_code = html_code.replaceAll("{{billing_phone}}", `Phone: ${tb.phone}`)
	// let ts = JSON.parse(ewayBillDetails.shipping_address)
	// html_code = html_code.replaceAll("{{shipping_address}}", `${ts.address_line1 == "" ? "" : ts.address_line1 + ", "}${ts.address_line2 == "" ? "" : ts.address_line2 + ", "}${ts.city == "" ? "" : ts.city + ", "}${ts.state == "" ? "" : ts.state + ", "}${ts.country == "" ? "" : ts.country + ", "}`)
	// html_code = html_code.replaceAll("{{shipping_pincode}}", `Pincode: ${ts.pincode}`)
	// html_code = html_code.replaceAll("{{shipping_phone}}", `Phone: ${ts.phone}`)

	// html_code = html_code.replaceAll("{{reference_no}}", ewayBillDetails.reference_number)
	// html_code = html_code.replaceAll("{{due_date}}", moment(ewayBillDetails.due_date).format("ll"))
	// html_code = html_code.replaceAll("{{place_of_supply}}", ewayBillDetails.place_of_supply)
	// html_code = html_code.replaceAll("{{document_total}}", JSON.parse(ewayBillDetails.invoice_currency).currency_symbol + " " + ewayBillDetails.grand_total)

	// let td = Tax_details.reduce((p, o) => {
	// 	if (p.hasOwnProperty(o.tax_type)) {
	// 		p[o.tax_type] += o.tax_amount
	// 	}
	// 	else {
	// 		p[o.tax_type] = o.tax_amount
	// 	}
	// 	return p
	// }, {})

	// let tax_column_count = 0
	// let tch1 = ""
	// let tch2 = ""
	// if (td.hasOwnProperty("CGST")) {
	// 	tch1 += `<th colspan="2">CGST</th>`
	// 	tch2 += `<th>%</th>
	// 	<th>Amt.</th>`
	// 	tax_column_count += 2
	// }
	// if (td.hasOwnProperty("SGST")) {
	// 	tch1 += `<th colspan="2">SGST</th>`
	// 	tch2 += `<th>%</th>
	// 	<th>Amt.</th>`
	// 	tax_column_count += 2
	// }
	// if (td.hasOwnProperty("UTGST")) {
	// 	tch1 += `<th colspan="2">UTGST</th>`
	// 	tch2 += `<th>%</th>
	// 	<th>Amt.</th>`
	// 	tax_column_count += 2
	// }
	// if (td.hasOwnProperty("IGST")) {
	// 	tch1 += `<th colspan="2">IGST</th>`
	// 	tch2 += `<th>%</th>
	// 	<th>Amt.</th>`
	// 	tax_column_count += 2
	// }

	// html_code = html_code.replaceAll("{{tax_column_count}}", tax_column_count)
	// html_code = html_code.replaceAll("{{tax_column_head1}}", tch1)
	// html_code = html_code.replaceAll("{{tax_column_head2}}", tch2)

	// let footer_row_count = 3
	// let fd1 = ""
	// if (td.hasOwnProperty("CGST")) {
	// 	fd1 += `<tr>
	// 		<td colspan="${tax_column_count}">CGST Total</td>
	// 		<td>${td["CGST"]}</td>
	// 	</tr>`
	// 	footer_row_count++
	// }
	// if (td.hasOwnProperty("SGST")) {
	// 	fd1 += `<tr>
	// 		<td colspan="${tax_column_count}">SGST Total</td>
	// 		<td>${td["SGST"]}</td>
	// 	</tr>`
	// 	footer_row_count++
	// }
	// if (td.hasOwnProperty("UTGST")) {
	// 	fd1 += `<tr>
	// 		<td colspan="${tax_column_count}">UTGST Total</td>
	// 		<td>${td["UTGST"]}</td>
	// 	</tr>`
	// 	footer_row_count++
	// }
	// if (td.hasOwnProperty("IGST")) {
	// 	fd1 += `<tr>
	// 		<td colspan="${tax_column_count}">IGST Total</td>
	// 		<td>${td["IGST"]}</td>
	// 	</tr>`
	// 	footer_row_count++
	// }

	// let fd2 = ""
	// if (ewayBillDetails.tax_category != null) {
	// 	fd2 = `<tr>
	// 		<td colspan="${tax_column_count}">TDS/TCS Total</td>
	// 		<td>${Math.round((ewayBillDetails.tax_category == "TDS" ? JSON.parse(ewayBillDetails.item_array).reduce((p, o) => { return p + ((o.quantity * o.rate) - (o.discount_type == "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) }, 0) : subTotal) * (ewayBillDetails.tax_id == null ? 0 : parseFloat(ewayBillDetails.tax_percentage)) / 100 * 1000) / 1000}</td>
	// 	</tr>`
	// 	footer_row_count++
	// }

	// html_code = html_code.replaceAll("{{subtotal}}", subTotal)

	// html_code = html_code.replaceAll("{{footer_row_count}}", footer_row_count)
	// html_code = html_code.replaceAll("{{tax_total_details}}", fd1)
	// html_code = html_code.replaceAll("{{tds_tcs_details}}", fd2)

	// html_code = html_code.replaceAll("{{adjustment_text}}", JSON.parse(ewayBillDetails.adjustment).text)
	// html_code = html_code.replaceAll("{{adjustment_value}}", JSON.parse(ewayBillDetails.adjustment).value)

	// let tw = new ToWords()
	// html_code = html_code.replaceAll("{{total_in_words}}", tw.convert(ewayBillDetails.grand_total) + " Only")
	// html_code = html_code.replaceAll("{{customer_note}}", ewayBillDetails.customer_notes)
	// html_code = html_code.replaceAll("{{terms_and_conditions}}", ewayBillDetails.terms_and_conditions)


	// let rs = html_code.indexOf("##")
	// let re = html_code.lastIndexOf("##")
	// let r_code = html_code.substring(rs + 2, re)

	// let acc = JSON.parse(ewayBillDetails.item_array).map((obj, i) => {
	// 	let temp = r_code
	// 	temp = temp.replaceAll("{{sl_no}}", i + 1)
	// 	temp = temp.replaceAll("{{description_of_goods}}", obj.item_name)
	// 	temp = temp.replaceAll("{{product_tax_code}}", obj.tax_code)
	// 	temp = temp.replaceAll("{{quantity}}", obj.quantity)
	// 	temp = temp.replaceAll("{{rate}}", obj.rate)
	// 	temp = temp.replaceAll("{{discount_amount}}", obj.discount_type == "amount" ? obj.discount_unit : Math.round((obj.rate * obj.quantity * Number(obj.discount_unit) / 100) * 1000) / 1000)
	// 	temp = temp.replaceAll("{{amount}}", Math.round((((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) + (obj.taxable == 0 ? 0 : ((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * (obj.tax_group_percentage / 100))) * 1000) / 1000)

	// 	let tcd = ""
	// 	if (td.hasOwnProperty("CGST")) {
	// 		let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "CGST")
	// 		if (v != undefined) {
	// 			tcd += `<td>${v.tax_percentage}%</td>
	// 			<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * 1000) / 1000) * v.tax_percentage / 100 * 1000) / 1000}</td>`
	// 		}
	// 		else {
	// 			tcd += `<td>--</td>
	// 			<td>--</td>`
	// 		}
	// 	}
	// 	if (td.hasOwnProperty("SGST")) {
	// 		let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "SGST")
	// 		if (v != undefined) {
	// 			tcd += `<td>${v.tax_percentage}%</td>
	// 			<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * 1000) / 1000) * v.tax_percentage / 100 * 1000) / 1000}</td>`
	// 		}
	// 		else {
	// 			tcd += `<td>--</td>
	// 			<td>--</td>`
	// 		}
	// 	}
	// 	if (td.hasOwnProperty("UTGST")) {
	// 		let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "UTGST")
	// 		if (v != undefined) {
	// 			tcd += `<td>${v.tax_percentage}%</td>
	// 			<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * 1000) / 1000) * v.tax_percentage / 100 * 1000) / 1000}</td>`
	// 		}
	// 		else {
	// 			tcd += `<td>--</td>
	// 			<td>--</td>`
	// 		}
	// 	}
	// 	if (td.hasOwnProperty("IGST")) {
	// 		let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "IGST")
	// 		if (v != undefined) {
	// 			tcd += `<td>${v.tax_percentage}%</td>
	// 			<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * 1000) / 1000) * v.tax_percentage / 100 * 1000) / 1000}</td>`
	// 		}
	// 		else {
	// 			tcd += `<td>--</td>
	// 			<td>--</td>`
	// 		}
	// 	}

	// 	temp = temp.replaceAll("{{tax_column_details}}", tcd)

	// 	return temp
	// }).join("")

	// html_code = html_code.substring(0, rs) + acc + html_code.substring(re + 2, html_code.length);

	// let link1 = nw.document.createElement('link');
	// link1.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
	// link1.rel = "stylesheet"
	// link1.integrity = "sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
	// link1.crossOrigin = "anonymous"
	// nw.document.head.appendChild(link1);

	// nw.document.body.innerHTML = html_code

	// setTimeout(() => { nw.print() }, 1000);
	// }

	const generateEwayBill = (organization_gstin) => {

		if (organization_gstin == null) {
			swal("Oops", "Please select a Gstin with E-Way Bill Configuration before generating E-Way Bill", "warning")
			return
		}

		var object = {}

		object.eway_bill_uid = props.match.params.id
		object.organization_gstin_uid = organization_gstin

		object.organization_id = organization_id
		object.page_name = page_name;

		console.log(object);
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/generate-e-way-bill`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				getEwayBillDetails()
				getEwayBillHistory()
				swal("Great!", `E Way Bill generated successfully!`, "success")
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const fetchEwayBill = (organization_gstin) => {
		if (ewayBillDetails.eway_bill_no == null) {
			swal("Oops", "No eway_bill_no available to fetch data", "warning")
			return
		}
		if (organization_gstin == null) {
			swal("Oops", "Please select a Gstin with E-Way Bill Configuration before fetching E-Way Bill", "warning")
			return
		}

		var object = {}

		object.eway_bill_uid = props.match.params.id
		object.organization_gstin_uid = organization_gstin

		object.organization_id = organization_id
		object.page_name = page_name;

		console.log(object);
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/fetch-e-way-bill`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				getEwayBillDetails()
				getEwayBillHistory()

				setFetchedEwayBillData(res.data.data.result)
				setFetchedDataModalShow(true)
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const cancelEwayBill = (organization_gstin) => {
		if (ewayBillDetails.eway_bill_no == null) {
			swal("Oops", "No eway_bill_no available to cancel data", "warning")
			return
		}
		if (organization_gstin == null) {
			swal("Oops", "Please select a Gstin with E-Way Bill Configuration before fetching E-Way Bill", "warning")
			return
		}

		var object = {}

		object.eway_bill_uid = props.match.params.id
		object.organization_gstin_uid = organization_gstin

		object.organization_id = organization_id
		object.page_name = page_name;

		console.log(object);
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-e-way-bill`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				getEwayBillDetails()
				getEwayBillHistory()
				swal("Great!", `E Way Bill data cancelled successfully!`, "success")
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	return (
		<>
			<div>
				<div className="d-flex flex-stack">
					<div className="page-title d-flex justify-content-center align-items-center flex-wrap gap-5">
						<h1 className="page-heading text-dark fw-bold fs-3 my-0">View Sales Return Details</h1>
						<Tooltip title="SpotERP Docs" >
							<a
								href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/e_way_bill#view-e-way-bill`}
								className='btn btn-light-primary py-2 px-3'
								target="_blank"
							>
								<i className="bi bi-journal-text fs-1 px-0"></i>
							</a>
						</Tooltip>
					</div>
				</div>
				<div>
					{
						state === 1 ?
							<div className="d-flex flex-column gap-7 gap-lg-10">
								<div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
									<ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto" role="tablist">
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_eway_bill_summary" aria-selected="true" role="tab">E-Way Bill Summary</a>
										</li>
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_eway_bill_history" aria-selected="false" role="tab" tabIndex="-1">E-Way Bill History</a>
										</li>
									</ul>

									{
										approveFinalButtonShow && ewayBillDetails.add_status === "EWAY_BILL_PENDING_APPROVAL" &&
										<button className='btn btn-primary btn-sm' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
											onClick={() => {
												swal("Alert!", "Are you sure, you want to proceed?", {
													buttons: {
														nothing: { text: "Cancel", className: "btn btn-secondary" },
														edit: { text: "Modify", className: "btn btn-warning" },
														approve: { text: "Approve", className: "btn btn-danger" },
													}
												})
													.then((value) => {
														switch (value) {
															case "edit": history.push(`/edit-dealer-invoice/${props.match.params.id}`); break;
															case "approve": approveEwayBillSubmit(true, false, ""); break;
														}
													});
											}}
										>
											<span className="indicator-label">Final Approve</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}
									{
										approveButtonShow && ewayBillDetails.add_status === "EWAY_BILL_PENDING_APPROVAL" &&
										<button className='btn btn-primary btn-sm' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
											onClick={() => {
												swal("Alert!", "Are you sure, you want to proceed?", {
													buttons: {
														nothing: { text: "Cancel", className: "btn btn-secondary" },
														edit: { text: "Modify", className: "btn btn-warning" },
														approve: { text: "Approve", className: "btn btn-danger" },
													}
												})
													.then((value) => {
														switch (value) {
															case "edit": history.push(`/edit-dealer-invoice/${props.match.params.id}`); break;
															case "approve": approveEwayBillSubmit(false, false, ""); break;
														}
													});
											}}
										>
											<span className="indicator-label">Approve</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}
									{
										cancelButtonShow && ewayBillDetails.add_status === "EWAY_BILL_PENDING_APPROVAL" &&
										<button className='btn btn-primary btn-sm' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
											onClick={() => {
												swal({
													title: "Alert!",
													text: "Please type a reason before cancelling",
													icon: "warning",
													content: "input",
													buttons: true,
													dangerMode: true,
												})
													.then((msg) => {
														if (msg == "") {
															swal("Alert!", "Message cannot be empty", "warning")
														}
														else if (msg) {
															approveEwayBillSubmit(false, true, msg);
														}
													});
											}}
										>
											<span className="indicator-label">Cancel</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}

									{
										write && ewayBillDetails.add_status === "EWAY_BILL_FINALIZED" && (!ewayBillDetails.eway_bill_no) &&
										<button type="button" className="btn btn-sm btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { setConfigGstinListModalShow(true); setConfigGstinListModalMode("generate"); }}>
											<span className="indicator-label">Generate E-Way Bill</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}
									{
										write && (ewayBillDetails.add_status === "EWAY_BILL_FINALIZED" || ewayBillDetails.add_status === "EWAY_BILL_GENERATED") && ewayBillDetails.eway_bill_no &&
										<button type="button" className="btn btn-sm btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { setConfigGstinListModalShow(true); setConfigGstinListModalMode("fetch"); }}>
											<span className="indicator-label">{ewayBillDetails.add_status === "EWAY_BILL_FINALIZED" ? "Verify & Fetch E-Way Bill" : "Fetch E-Way Bill"}</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}
									{
										write && ewayBillDetails.add_status === "EWAY_BILL_GENERATED" &&
										<button type="button" className="btn btn-sm btn-success" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { setConfigGstinListModalShow(true); setConfigGstinListModalMode("cancel"); }}>
											<span className="indicator-label">Cancel E-Way Bill</span>
											<span className="indicator-progress">Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
									}
									{
										(
											ewayBillDetails.add_status === "EWAY_BILL_DRAFT" ||
											ewayBillDetails.add_status === "EWAY_BILL_PENDING_APPROVAL" ||
											ewayBillDetails.add_status === "EWAY_BILL_FINALIZED"
										) && <Link className="btn btn-sm btn-info" to={`/edit-e-way-bill/${props.match.params.id}`}>Edit E-Way Bill</Link>
									}
								</div>
								<div className="tab-content">
									<div className="tab-pane fade active show" id="kt_eway_bill_summary" role="tab-panel">

										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card card-flush py-6 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>E-Way Bill Details (#{ewayBillDetails.document_number})</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Status
																			</div>
																		</td>
																		<td className="fw-bold text-end">
																			<div style={{ position: "relative", display: "inline-block" }} >
																				<button className={
																					`py-2 me-1 rounded btn btn-sm btn-${ewayBillDetails.add_status === "EWAY_BILL_PENDING_APPROVAL"
																						? "warning"
																						: ewayBillDetails.add_status === "EWAY_BILL_FINALIZED"
																							? "success"
																							: "secondary"
																					}`
																				}
																					onClick={() => { setApprovalChainPopup(true); }}
																					onBlur={() => { setApprovalChainPopup(false) }}
																				>
																					{ewayBillDetails.add_status.replace("EWAY_BILL", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
																				</button>
																				<div style={{ position: "absolute", right: "0px", top: "30px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#FFFFFF", color: "black", padding: "1rem", width: "25rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: approvalChainPopup ? "1" : "0", visibility: approvalChainPopup ? "visible" : "hidden" }}>
																					{
																						ewayBillDetails.approval_info.type == "multilevel_approval" ?
																							<>
																								<div className='text-center border-bottom fs-4'>Multilevel Approval</div>
																								<div>
																									{
																										ewayBillDetails.approval_info.value.map((obj, i) => {
																											return (
																												<div key={i} className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																													<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																													<div className='flex-grow-1 text-start'>
																														<div className='fs-4'>Level {obj.level}</div>
																														{
																															obj.user_value.map((val, j) => {
																																return <div key={j} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																															})
																														}
																													</div>
																													<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																												</div>
																											)
																										})
																									}

																									<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																										<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																										<div className='fs-4'>Approved</div>
																									</div>
																								</div>
																							</>
																							:
																							ewayBillDetails.approval_info.type == "custom_approval" &&
																							<>
																								<div className='text-center border-bottom fs-4'>Custom Approval</div>
																								<div>
																									<div className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																										<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																										<div className='flex-grow-1 text-start'>
																											<div className='fs-4'>{ewayBillDetails.approval_info.value[0].user_type}</div>
																											{
																												ewayBillDetails.approval_info.value[0].user_value.map((val, i) => {
																													return <div key={i} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																												})
																											}
																										</div>
																										<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																									</div>
																									<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																										<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																										<div className='fs-4'>Approved</div>
																									</div>
																								</div>
																							</>
																					}
																				</div>
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>E-Way Bill Date
																			</div>
																		</td>
																		<td className="fw-bold text-end">{moment(ewayBillDetails.eway_bill_date).format("ll")}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Document Number
																			</div>
																		</td>
																		<td className="fw-bold text-end">{ewayBillDetails.document_number}</td>
																	</tr>
																	{
																		ewayBillDetails.eway_bill_no &&
																		<tr>
																			<td className="text-muted">
																				<div className="d-flex align-items-center">
																					<span className="svg-icon svg-icon-2 me-2">
																						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																							<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																							<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																							<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																						</svg>
																					</span>E-Way Bill Number
																				</div>
																			</td>
																			<td className="fw-bold text-end">{ewayBillDetails.eway_bill_no}</td>
																		</tr>
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div className="card card-flush py-6 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>GSTIN Details</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>GST Treatment
																			</div>
																		</td>
																		<td className="fw-bold text-end">{GST_Details.gst_treatment}</td>
																	</tr>
																	<tr style={{ display: GST_Details.gst_treatment === "Consumer" || GST_Details.gst_treatment === "Unregistered Business" ? "none" : "table-row" }}>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>GSTIN
																			</div>
																		</td>
																		<td className="fw-bold text-end">{GST_Details.GstIn}</td>
																	</tr>
																	<tr style={{ display: GST_Details.gst_treatment === "Consumer" || GST_Details.gst_treatment === "Unregistered Business" ? "none" : "table-row" }}>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Trade Name
																			</div>
																		</td>
																		<td className="fw-bold text-end">{GST_Details.trade_name !== "" ? GST_Details.trade_name : "No trade name provided"}</td>
																	</tr>
																	<tr style={{ display: GST_Details.gst_treatment === "Consumer" || GST_Details.gst_treatment === "Unregistered Business" ? "none" : "table-row" }}>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Legal Name
																			</div>
																		</td>
																		<td className="fw-bold text-end">{GST_Details.legal_name}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card card-flush py-6 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>User Details</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
																						<path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
																						<rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
																					</svg>
																				</span>User Name
																			</div>
																		</td>
																		<td className="fw-bold text-end">{ewayBillDetails.doc_user_name}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
																						<path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
																					</svg>
																				</span>User Email
																			</div>
																		</td>
																		<td className="fw-bold text-end">{ewayBillDetails.doc_user_email !== "" ? ewayBillDetails.doc_user_email : "No email address added"}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div className="card card-flush py-6 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>Other Details</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Warehouse
																			</div>
																		</td>
																		<td className="fw-bold text-end">{warehouseList.length > 0 && ewayBillDetails != null && warehouseList.find(x => x.wid === ewayBillDetails.warehouse_id).name}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path d="M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z" fill="currentColor"></path>
																					</svg>
																				</span>Place Of Delivery
																			</div>
																		</td>
																		<td className="fw-bold text-end">{ewayBillDetails.place_of_delivery}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card card-flush py-4 flex-row-fluid overflow-hidden">
													<div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
														<img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-175px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Billing Address</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="address-info">
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {Billing_address.city}, {Billing_address.state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {Billing_address.pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {Billing_address.country}
															</div>
														</div>
													</div>
												</div>
												<div className="card card-flush py-4 flex-row-fluid overflow-hidden">
													<div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
														<img src="/assets/media/icons/duotune/ecommerce/ecm006.svg" className="w-175px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Shipping Address</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="address-info">
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {Shipping_address.city}, {Shipping_address.state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {Shipping_address.pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {Shipping_address.country}
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="card card-flush py-4 flex-row-fluid overflow-hidden">
												<div className="card-header align-items-center py-5 gap-2 gap-md-5">
													<div className="card-title">
														<h2>E-Way Bill #{ewayBillDetails.document_number}</h2>
													</div>
												</div>
												<div className="card-body pt-0">
													<div className="d-flex justify-content-between flex-column">
														<div className="table-responsive border-bottom mb-9">
															<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																<thead>
																	<tr className="border-bottom fs-6 fw-bold text-muted">
																		<th className="min-w-100px">Products</th>
																		<th className="min-w-70px">Rate<br />(Tax Exclusive)</th>
																		<th className="min-w-70px">Rate<br />(Tax Inclusive)</th>
																		<th className="min-w-80px">QTY</th>
																		<th className="min-w-70px">Discount</th>
																		<th className="min-w-70px">Total Amt.<br />Excl.</th>
																		<th className="min-w-70px">Tax Percentage</th>
																		<th className="min-w-70px">Tax Amount</th>
																		<th className="min-w-100px text-end pb-2">Total</th>
																	</tr>
																</thead>
																<tbody className="fw-semibold text-gray-600">
																	{Item_details.map((Obj, index) => {
																		return (
																			<tr key={index}>
																				<td>
																					<div className="fw-bold">
																						<div className="fw-bold">{Obj.item_name}</div>
																						{Obj.tax_code !== "" && <span className="badge badge-light-primary me-2">{Obj.tax_code_type}: {Obj.tax_code}</span>}
																					</div>
																				</td>
																				<td>{Math.round(Obj.TAX_Exclusive_Price * 1000) / 1000}</td>
																				<td>{Math.round(Obj.TAX_Inclusive_Price * 1000) / 1000}</td>
																				<td>{Obj.quantity}</td>
																				<td>
																					<div className="fw-bold">
																						<div className="fw-bold">
																							{Obj.discount_type === "amount" ? <>{Obj.discount_unit}</> : <>{Math.round((Obj.rate * Obj.quantity * Number(Obj.discount_unit) / 100) * 1000) / 1000}</>}</div>
																						{Obj.discount_type !== "amount" && <span className="badge badge-light-primary me-2">{Obj.discount_type !== "amount" && <>{Obj.discount_unit} %</>}</span>}
																					</div>
																				</td>
																				<td>{Math.round(((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * 1000) / 1000}</td>
																				{Obj.taxable === 1 ? <td><div className="ms-5"><div>{Obj.tax_group_name} ({Obj.tax_group_percentage}%)</div><div className="mb-8">
																					{Obj.tax_group_details.map((Obj1, index1) => {
																						return (
																							<span key={index1} className="badge badge-light-primary me-2">{Obj1.tax_name} ({Obj1.tax_percentage}%)</span>
																						)
																					})}
																				</div></div></td> : <td>---</td>}
																				<td>{Math.round((Obj.taxable === 0 ? 0 : ((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * (Obj.tax_group_percentage / 100)) * 1000) / 1000}</td>
																				<td className="text-end">{Math.round((((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) + (Obj.taxable === 0 ? 0 : ((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * (Obj.tax_group_percentage / 100))) * 1000) / 1000}</td>
																			</tr>
																		)
																	})}

																</tbody>
															</table>
														</div>
														<div className="row flex-column-reverse flex-md-row">
															<div className="col-md-6 py-1">
																<div className="mw-md-200px">
																	<div className="fw-semibold mb-3 text-dark">Tax Calculation</div>
																	{
																		Tax_details.map((Obj, index) => {
																			return (
																				<div key={index} className="d-flex flex-stack text-gray-800 mb-3 fs-6">
																					<div className="fw-semibold pe-5">{Obj.tax_name} ({Obj.tax_percentage}%):</div>
																					<div className="text-end fw-normal"> {Obj.tax_amount || 0}</div>
																				</div>
																			)
																		})
																	}
																</div>
															</div>

															<div className="col-md-6 py-1">
																<div className="mw-md-300px ms-md-auto">
																	<div className="d-flex flex-stack mb-3">
																		<div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal:</div>
																		<div className="text-end fw-bold fs-6 text-gray-800">{subTotal}</div>
																	</div>
																	<div className="d-flex flex-stack mb-3">
																		<div className="fw-semibold pe-10 text-gray-600 fs-7">Tax Percentage {ewayBillDetails.tax_percentage !== null && <>({ewayBillDetails.tax_name}-{ewayBillDetails.tax_percentage}%)</>}</div>
																		<div className="text-end fw-bold fs-6 text-gray-800">{Math.round((ewayBillDetails.tax_category === "TDS" ? Item_details.reduce((p, o) => { return p + ((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) }, 0) : subTotal) * (ewayBillDetails.tax_id == null ? 0 : parseFloat(ewayBillDetails.tax_percentage)) / 100 * 1000) / 1000}</div>
																	</div>
																	<div className="d-flex flex-stack mb-3">
																		<div className="fw-semibold pe-10 text-gray-600 fs-7">{Adjustment_text}</div>
																		<div className="text-end fw-bold fs-6 text-gray-800">{Adjustment_value}</div>
																	</div>
																	<div className="d-flex flex-stack">
																		<div className="fw-semibold pe-10 text-gray-600 fs-7">Total</div>
																		<div className="text-end fw-bold fs-6 text-gray-800">{ewayBillDetails.grand_total}</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="tab-pane fade" id="kt_eway_bill_history" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="card card-flush py-4 flex-row-fluid">
												<div className="card-header">
													<div className="card-title">
														<h2>E-Way Bill History</h2>
													</div>
												</div>

												<div className="card-body pt-0">
													{
														ewayBillHistory.length > 0 &&
														<div className="table-responsive">
															<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																<thead>
																	<tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
																		<th className="min-w-100px">Date Added</th>
																		<th className="min-w-100px">Operation</th>
																		<th className="min-w-175px">Comment</th>
																		<th className="min-w-70px">Bill Status</th>
																		<th className="min-w-100px">Customer Notifed</th>
																	</tr>
																</thead>
																<tbody className="fw-semibold text-gray-600">
																	{ewayBillHistory.map((Obj, index) => {
																		return (
																			<tr key={index}>
																				<td>{moment(Obj.timestamp).format("ll")}</td>
																				<td>{Obj.operation}</td>
																				<td>{Obj.operation_message}</td>
																				<td><StatusBadge status={Obj.eway_bill_status} entity={"EWAY_BILL"} /></td>
																				<td>No</td>
																			</tr>
																		)
																	})}
																</tbody>
															</table>
														</div>
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							: state === 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError message={failedPageMessage}>
									<Link to={`/e-way-bill-list`} className="btn btn-sm btn-primary me-3 rounded cursor-pointer">Go to E-Way Bill List</Link>
								</PageError>
					}
				</div>
			</div>

			<Modal show={configGstinListModalShow} onHide={() => { setConfigGstinListModalShow(false); setConfigGstinListModalMode(null); setSelectedOrganizationGstin(null); }} centered>
				<Modal.Header>
					<Modal.Title>Choose a GSTIN</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setConfigGstinListModalShow(false); setConfigGstinListModalMode(null); setSelectedOrganizationGstin(null); }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
					<div className='container'>
						{
							configGstinList.length === 0 ?
								<div className="overflow-auto pb-5">
									<div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
										<span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
												<path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
											</svg>
										</span>
										<div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
											<div className="mb-3 mb-md-0 fw-semibold">
												<h4 className="text-gray-900 fw-bold">No Gstin Configured yet.</h4>
											</div>
										</div>
									</div>
								</div>
								:

								<div className="d-flex flex-column gap-5">
									{
										configGstinList.sort((a, b) => a.add_date_time - b.add_date_time).map((obj, index) => {
											return (
												<div key={index} className="position-relative fv-row w-100 flex-md-root" style={{ cursor: "pointer" }} onClick={() => { setSelectedOrganizationGstin(obj.gstin_uid); }}>
													<div className="card card-flush h-lg-100">
														<div className="card-header mt-6">
															<div className="card-title flex-column"><h3 className="fw-bolder mb-1">{obj.gstin_number}</h3></div>
														</div>
														<div className="d-flex flex-wrap">
															<div className="card-body p-9">
																<div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
																	<div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
																	<div className="fw-semibold text-gray-400">Business Legal Name</div>
																</div>
																<div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
																	<div className="fs-6 fw-bold text-gray-700">{obj.trade_name}</div>
																	<div className="fw-semibold text-gray-400">Business Trade Name</div>
																</div>
															</div>
														</div>
													</div>
													{
														selectedOrganizationGstin != null && selectedOrganizationGstin === obj.gstin_uid &&
														<div className='position-absolute' style={{ top: "2.8rem", right: "11rem" }} >
															<svg width="30" height="30" viewBox="0 0 64 64">
																<path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
															</svg>
														</div>
													}
												</div>
											)
										})
									}
								</div>

						}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-danger rounded" onClick={() => { setConfigGstinListModalShow(false); setConfigGstinListModalMode(null); setSelectedOrganizationGstin(null); }}>Close</button>
					<button
						className="btn btn-success rounded"
						onClick={() => {
							if (configGstinListModalMode === "generate") {
								generateEwayBill(selectedOrganizationGstin)
							}
							else if (configGstinListModalMode === "fetch") {
								fetchEwayBill(selectedOrganizationGstin)
							}
							else if (configGstinListModalMode === "cancel") {
								cancelEwayBill(selectedOrganizationGstin)
							}

							setConfigGstinListModalShow(false);
							setConfigGstinListModalMode(null);
							setSelectedOrganizationGstin(null);
						}}
					>Proceed
					</button>
				</Modal.Footer>
			</Modal>

			<Modal show={fetchedDataModalShow} onHide={() => { setFetchedDataModalShow(false); setFetchedEwayBillData(null); }} centered size='xl'>
				<Modal.Header>
					<Modal.Title>Fetched E-Way Bill Data</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFetchedDataModalShow(false); setFetchedEwayBillData(null); }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
					<div className='container'>
						<EwayBillDetails data={fetchedEwayBillData} />
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-danger rounded" onClick={() => { setFetchedDataModalShow(false); setFetchedEwayBillData(null); }}>Close</button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

const EwayBillDetails = ({ data }) => {
	if (!data || Object.keys(data).length === 0) {
		return <p>No data to display.</p>;
	}

	const excludedKeys = ['itemList', 'VehiclListDetails']; // Keys to handle separately

	return (
		<div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
			<h2 style={{ color: '#333' }}>E-Way Bill Details</h2>

			<div style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '5px', marginBottom: '15px' }}>
				<h3 style={{ color: '#555', marginBottom: '10px' }}>General Information</h3>
				{
					Object.entries(data)
						.filter(([key]) => !excludedKeys.includes(key))
						.map(([key, value]) => (
							<p key={key}>
								<span className="fw-bold">{key}:</span> {typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}
							</p>
						))
				}
			</div>

			{data.itemList && data.itemList.length > 0 && (
				<div style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '5px', marginBottom: '15px' }}>
					<h3 style={{ color: '#555', marginBottom: '10px' }}>Item List</h3>
					<table style={{ width: '100%', borderCollapse: 'collapse' }}>
						<thead>
							<tr style={{ backgroundColor: '#f2f2f2' }}>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Item No</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Product Name</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>HSN Code</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>Quantity</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Unit</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'right' }}>Taxable Amount</th>
							</tr>
						</thead>
						<tbody>
							{data.itemList.map((item) => (
								<tr key={item.itemNo}>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.itemNo}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.productName}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.hsnCode}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee', textAlign: 'right' }}>{item.quantity}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.qtyUnit}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee', textAlign: 'right' }}>₹{item.taxableAmount}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}

			{data.VehiclListDetails && data.VehiclListDetails.length > 0 && (
				<div style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '5px', marginBottom: '15px' }}>
					<h3 style={{ color: '#555', marginBottom: '10px' }}>Vehicle List Details</h3>
					<table style={{ width: '100%', borderCollapse: 'collapse' }}>
						<thead>
							<tr style={{ backgroundColor: '#f2f2f2' }}>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Vehicle No</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>From Place</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>From State</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Transporter GSTIN</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Entered Date</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Transport Mode</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Document No</th>
								<th style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Document Date</th>
							</tr>
						</thead>
						<tbody>
							{data.VehiclListDetails.map((vehicle) => (
								<tr key={vehicle.vehicleNo}>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.vehicleNo}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.fromPlace}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.fromState}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.userGSTINTransin}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.enteredDate}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.transMode}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.transDocNo}</td>
									<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{vehicle.transDocDate}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default ViewEwayBill;
